// extracted by mini-css-extract-plugin
export var button = "_np-2";
export var card = "_np-0";
export var closeButtonContainer = "_np-3";
export var iconContainer = "_np-1";